import { NavLink, useLocation } from 'react-router-dom';

import { useTranslation } from '../design-system/data/translations';
import { ClockIcon, HouseIcon, LayersIcon, SettingsIcon } from '../icons';

export function BottomNavigation() {
  const { t } = useTranslation();
  const location = useLocation();
  const links = [
    { to: '/today', label: t('nav.today'), Icon: HouseIcon },
    { to: '/history', label: t('history.title'), Icon: ClockIcon },
    { to: '/settings', label: t('settings.title'), Icon: SettingsIcon },
    { to: '/architecture', label: t('architecture.title'), Icon: LayersIcon },
  ];

  return (
    <nav aria-label={t('nav.aria')} className="bottom-nav">
      {links.map(({ to, label, Icon }) => {
        const active = location.pathname === to || (to === '/today' && location.pathname === '/');
        return (
          <NavLink
            key={to}
            to={to}
            className={`bottom-nav__link${active ? ' bottom-nav__link--active' : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            <Icon className="bottom-nav__icon" aria-hidden="true" />
            <span className="bottom-nav__label">{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
